export const getYear = state => state.reportVehicleTraffic.getIn(['list', 'year'])
export const getData = state => state.reportVehicleTraffic.getIn(['list', 'data'])
export const getFetching = state => state.reportVehicleTraffic.getIn(['list', 'fetching'])
export const getError = state => state.reportVehicleTraffic.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehicleTraffic.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehicleTraffic.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehicleTraffic.getIn(['details', 'error'])
